module.exports = __webpack_public_path__ + "img/181-trinidad-and-tobago.8b05f8ef.svg";